module.exports = __webpack_public_path__ + "img/ico_badge01.c2ed2980.svg";